module.exports = __webpack_public_path__ + "023ca60c570fba37879a9bb1d0a280ac.svg";